<template lang='pug'>
  .sidebar-container
    .section
      .title(v-text='accountTitle')
      template(v-for='link in accountLinks')
        router-link.item(v-if='link.routerLinked' @click='trackBeautyProfileClick(link.path)' :to='{ path: link.path }' v-text='link.label')
        a.item(v-else @click='trackBeautyProfileClick(link.path)' :href='link.path' v-text='link.label')
    hr.hr
    .section
      .title(v-text='beautyPassTitle')
      template(v-for='link in beautyPassLinks')
        router-link.item(v-if='link.routerLinked' :to='{ path: link.path }' v-text='link.label')
        a.item(v-else :href='link.path' v-text='link.label')
</template>

<script>
import { pushDataLayerEvent } from '@/modules/services/gtm'

export default {
  props: [
    'accountTitle',
    'accountLinks',
    'beautyPassTitle',
    'beautyPassLinks'
  ],

  methods: {
    trackBeautyProfileClick (path) {
      if (path === '/account/beauty-profile') pushDataLayerEvent('beautyprofile_click_entry')
    }
  }
}
</script>

<style lang='scss' scoped>
  .sidebar-container {
    @include media-breakpoint-up(sm) {
      display: block;
      margin-right: 10px;
    }

    @include media-breakpoint-up(lg) {
      display: block;
    }

    > .section {
      text-align: left;
    }

    > .hr {
      margin-bottom: 18px;
      margin-top: 18px;
      opacity: 0.5;
    }
  }

  .section {
    > .title {
      @include font-weight-medium;
      text-transform: uppercase;
    }

    > .item {
      display: block;
      margin-top: 16px;
    }
  }
</style>
